module.exports = __webpack_public_path__ + "assets/img/3_1386.1fe97901.jpg";